import { AbstractControl, ValidationErrors } from '@angular/forms';

export const digits = (control: AbstractControl): ValidationErrors | null => {
  const key = 'digits';

  const value = control.value;

  if (!value) return null;

  const result = /^\d+$/.test(value);

  if (!result)
    return {
      [key]: true,
    };

  return null;
};
